import UserService from '../utils/services/UserService';
import { SET_LOGGED_USER_PROFILE, GET_LOGGED_USER_PROFILE } from './userTypes';
import { storeKeys } from '../utils/helpers/storageManager';

import { authSuccess } from './authActionCreators';
import { viewSpinner, hideSpinner } from './general';
import { SET_PROFILE, CLEAR_PROFILE } from './profileTypes';
import {
  customNotification,
  errorGeneralNotification,
  successNotification,
} from './notifications';

export const getProfileStart = () => ({
  type: GET_LOGGED_USER_PROFILE,
});

export const setAuthenticatedProfile = (
  userId,
  email,
  name,
  permissions,
  profileId,
  partner,
  referenceCode
) => {
  const propsToStore = {
    userId,
    email,
    name,
    permissions,
    profileId,
    partner,
    referenceCode,
  };
  storeKeys(propsToStore);
  storeKeys({
    permissions: JSON.stringify(permissions),
  });

  return {
    type: SET_LOGGED_USER_PROFILE,
    ...propsToStore,
  };
};

export const getProfileFromToken = token => dispatch => {
  dispatch(getProfileStart());
  UserService.getProfileByToken(token)(
    res => {
      if (res.data && res.data.data) {
        const { userId, email, profile } = res.data.data;
        const {
          name,
          partner,
          permissions,
          profileId,
          referenceCode,
        } = profile;
        dispatch(
          setAuthenticatedProfile(
            userId,
            email,
            name,
            permissions,
            profileId,
            partner,
            referenceCode
          )
        );
        dispatch(authSuccess(token));
      }
    },
    () => {
      dispatch(hideSpinner());
    },
    () => {
      dispatch(errorGeneralNotification());
    }
  );
};
const setProfile = user => {
  const { email, userId, profile } = user;
  const { name, partner, permissions, referenceCode } = profile;
  return {
    type: SET_PROFILE,
    email,
    userId,
    name,
    partner,
    permissions,
    referenceCode,
  };
};
export const clearProfile = () => ({
  type: CLEAR_PROFILE,
});
export const getProfileFromUserId = userId => dispatch => {
  dispatch(viewSpinner());
  UserService.getProfileByUserId(userId)(
    res => {
      const user = res.data.data;
      dispatch(setProfile(user));
    },
    () => {
      dispatch(hideSpinner());
    },
    () => {
      dispatch(errorGeneralNotification());
    }
  );
};
export const getClientAreaProfileFromUserId = (
  userId,
  onSuccess = () => {},
  onComplete = () => {}
) => () => {
  UserService.getClientAreaProfileByUserId(userId)(
    res => {
      onSuccess(res.data.data);
    },
    () => {
      onComplete();
    },
    () => {}
  );
};

export const patchUsers = values => dispatch => {
  dispatch(viewSpinner());
  const {
    userId,
    profile: {
      name,
      zone,
      entryDate,
      departureDate,
      salary,
      monthlyGoal,
      monthlyBonus,
      status,
    },
    email,
    positionId,
    departmentId,
    groupId,
    supervisorId,
    isSupervisor,
  } = values;

  const params = {
    name,
    zone,
    entryDate,
    departureDate,
    salary,
    monthlyGoal,
    monthlyBonus,
    email,
    positionId,
    departmentId,
    groupId,
    supervisorId,
    isSupervisor,
    status,
  };

  UserService.patchUsers(userId, params)(
    () => {
      dispatch(successNotification('Usuario editado correctamente!'));
    },
    () => {
      dispatch(hideSpinner());
    },
    () => {
      dispatch(customNotification('Error', 'Este usuario ya existe', 'error'));
    }
  );
};



// WEBPACK FOOTER //
// ./src/actions/userActionCreators.js